import React, { useState } from 'react';
import ChatMenu from '../chat/ChatMenu';
import SubscriptionPanel from './SubscriptionPanel';
import TemplateSettings from './TemplateSettings';
import AlertSettings from './AlertSettings';
import CreditSettings from './CreditSettings';

type SettingsTab = 'subscription' | 'templates' | 'alerts' | 'credit';

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState<SettingsTab>('templates');

  return (
    <div className="flex h-screen bg-jobesta-gray-20">
      <ChatMenu />
      <div className="flex-1 overflow-auto">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          {/* Page Header */}
          <h1 className="text-2xl font-bold text-jobesta-gray-90 mb-6">Settings</h1>

          {/* Tab Navigation */}
          <div className="flex gap-2 mb-6 border-b border-jobesta-gray-40">
            <button
              onClick={() => setActiveTab('subscription')}
              className={`px-6 py-3 font-medium transition-colors ${
                activeTab === 'subscription'
                  ? 'text-jobesta-blue border-b-2 border-jobesta-blue'
                  : 'text-jobesta-gray-60 hover:text-jobesta-gray-90'
              }`}
            >
              Subscription
            </button>
            <button
              onClick={() => setActiveTab('templates')}
              className={`px-6 py-3 font-medium transition-colors ${
                activeTab === 'templates'
                  ? 'text-jobesta-blue border-b-2 border-jobesta-blue'
                  : 'text-jobesta-gray-60 hover:text-jobesta-gray-90'
              }`}
            >
              Templates
            </button>
            <button
              onClick={() => setActiveTab('alerts')}
              className={`px-6 py-3 font-medium transition-colors ${
                activeTab === 'alerts'
                  ? 'text-jobesta-blue border-b-2 border-jobesta-blue'
                  : 'text-jobesta-gray-60 hover:text-jobesta-gray-90'
              }`}
            >
              Alerts
            </button>
            <button
              onClick={() => setActiveTab('credit')}
              className={`px-6 py-3 font-medium transition-colors ${
                activeTab === 'credit'
                  ? 'text-jobesta-blue border-b-2 border-jobesta-blue'
                  : 'text-jobesta-gray-60 hover:text-jobesta-gray-90'
              }`}
            >
              Credit
            </button>
          </div>

          {/* Tab Content */}
          <div>
            {activeTab === 'subscription' && <SubscriptionPanel />}
            {activeTab === 'templates' && <TemplateSettings />}
            {activeTab === 'alerts' && <AlertSettings />}
            {activeTab === 'credit' && <CreditSettings />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
